module.exports = __webpack_public_path__ + "img/shelf-life.fb18c4e4.png";